var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Popper from '@material-ui/core/Popper';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
var PopperNew = function (_a) {
    var anchor = _a.anchor, children = _a.children, container = _a.container, isDisabled = _a.isDisabled, modifiers = _a.modifiers, onBtnClick = _a.onBtnClick, onClose = _a.onClose, onOpen = _a.onOpen, openOnMouseEnter = _a.openOnMouseEnter, placement = _a.placement;
    var anchorElement = React.useRef(null);
    var _b = React.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var handleClose = React.useCallback(function () {
        setIsOpen(false);
        if (onClose) {
            onClose();
        }
    }, [onClose, setIsOpen]);
    var handleOpen = React.useCallback(function () {
        if (isDisabled) {
            return;
        }
        setIsOpen(true);
        if (onOpen) {
            onOpen();
        }
    }, [isDisabled, onOpen, setIsOpen]);
    var handleClick = React.useCallback(function () {
        if (onBtnClick) {
            onBtnClick();
        }
        handleOpen();
    }, [handleOpen, onBtnClick]);
    var handleMouseEnter = React.useCallback(function () {
        if (openOnMouseEnter) {
            handleOpen();
        }
    }, [handleOpen, openOnMouseEnter]);
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "anchor", onClick: handleClick, onMouseEnter: handleMouseEnter, ref: anchorElement }, anchor),
        React.createElement(Popper, { anchorEl: anchorElement.current, container: container, modifiers: modifiers, open: isOpen, 
            // It's the same zIndex that MUI Modal has, so when we open MapPreview in SearchMap we can see it
            placement: placement, style: { position: 'absolute', zIndex: 1300 }, transition: true }, function (_a) {
            var TransitionProps = _a.TransitionProps;
            return (React.createElement(ClickAwayListener, { onClickAway: handleClose },
                React.createElement(Grow, __assign({}, TransitionProps),
                    React.createElement(Paper, null, children({ handleClose: handleClose })))));
        })));
};
export default PopperNew;
//# sourceMappingURL=Popper.js.map